const CLASS_NAME_FADE_IN = 'fadeIn';

export { CLASS_NAME_FADE_IN };
